/* Theme functions */

var theme = {
    /**
     * Equalizes the height of a given group of elements, making them all
     * at least as big as the largest of the group (but not restricting future
     * expansion. You may optionally pass in a parent selector by which the
     * elements will be equalized (each instance of the group selector will be
     * given equal heights within their parent, rather than across all elements
     * matching that selector globally).
     * @param string group
     * @param string parent
     */
    equalHeight: function (group, parent) {
        parent = parent || "body";
        jQuery(parent).each(function () {
            tallest = 0;
            jQuery(this).find(group).each(function () {
                var $this = jQuery(this);

                thisHeight = $this.height();
                if ($this.css('box-sizing') === 'content-box') {
                    if (thisHeight > tallest) {
                        tallest = thisHeight;
                    }
                } else {
                    thisPadding = Number($this.css('padding-top').replace('px', ''))
                        + Number($this.css('padding-bottom').replace('px', ''));

                    if ((thisHeight + thisPadding) > tallest) {
                        tallest = thisHeight + thisPadding;
                    }
                }
            });
            jQuery(this).find(group).css('min-height', tallest);
        });
    },
    trim: function (x) {
        return x.replace(/^\s+|\s+$/gm, '');
    },
};

/* Event Handlers */
(function ($, $PB) {

    // Automatically equalize height on specified elements
    $(window).on('load', function () {
        theme.equalHeight('.equal');
        $(window).trigger('resize').trigger('scroll');

        setInterval(function() {
            jQuery(window).trigger('resize').trigger('scroll');
        }, 1000);
    });

    $("#menu-wrapper").mmenu(
        {
            "navbar": {
                "title": 'Securonix',
            },
            "extensions": [
                "pagedim-black",
                "theme-dark",
                "position-right"
            ]
        }
    );

    $('.search-bar .search-button').on('click', function(){
        $(this).parent().toggleClass('open');
    });

    $(window).on("hashchange", function() {
        var $departments = $(".departments-content");

        var $team_bar = $(".team-nav-bar");

        if (location.hash == "" && $departments.length > 0) {

            location.hash = $team_bar.find("a:first-child")
                .addClass("active")
                .attr("href");
        } else if ($departments.length == 0) {
            return;
        }

        var $pages = $departments.find(".team-page");

        $pages.removeClass("active");
        $team_bar.find("a").removeClass("active");

        $team_bar.find("[href='" + location.hash + "']").addClass("active");
        $departments.find("[data-tab='" + location.hash.replace("#", "") + "']")
            .addClass("active");
    });

    $(window).trigger("hashchange");

    $('.single-accordion .accordion-header').on('click', function() {
        var $column = $(this).parent();
        $column.toggleClass('open');
        $column.find('.accordion-inner').slideToggle({
            duration: 250,
            progress: function() {
                $(window).trigger('resize');
            }
        });
    });

    $('.tab-column ul.tabs-wrap li').on('click', function(){
        var $tab_id = $(this).attr('data-tab');

        $('.tab-column ul.tabs-wrap li').addClass('inactive');

        $(this).removeClass('inactive');

        $('.tab-content').removeClass('open');

        $("#"+$tab_id).addClass('open');

    });

    $(".searchandfilter input, .searchandfilter select").on("change", function(){
        this.form.submit();
    });

    $('.builder-layout-marquee-text .marquee').marquee({
        //If you wish to always animate using jQuery
        allowCss3Support: true,
        //works when allowCss3Support is set to true
        css3easing: 'linear',
        //requires jQuery easing plugin. Default is 'linear'
        easing: 'linear',
        //pause time before the next animation turn in milliseconds
        //delayBeforeStart: 1000,
        //'left', 'right', 'up' or 'down'
        direction: 'left',
        //true or false - should the marquee be duplicated to show an effect of continues flow
        duplicated: true,
        //speed in milliseconds of the marquee in milliseconds
        duration: 10000,
        //gap in pixels between the tickers
        gap: 20,
        //on cycle pause the marquee
        pauseOnCycle: false,
        //on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
        pauseOnHover: true,
        //the marquee is visible initially positioned next to the border towards it will be moving
        startVisible: false
    });

    $('.builder-layout-marquee-text .marquee').css('visibility', 'visible');

    // Turn into a plugin?
    // quick search regex
    var qsRegex;
    var filterBy = '';

    // init Isotope
    var $grid = $('.partners-row').isotope({
        itemSelector: '.single-partner-block',
        layoutMode: 'fitRows',
        filter: function() {
            if (filterBy != '') {
                if ($(this).is(filterBy)) {
                    return qsRegex ? $(this).attr('data-title').match( qsRegex ) : true;
                }
            } else {
                return qsRegex ? $(this).attr('data-title').match( qsRegex ) : true;
            }
        }
    });

    // bind sort button click
    $('.filters-wrap').on( 'click', '.cat-link', function() {
        var $parent = $(this).parents('.filters-wrap');
        var $checkboxes = $parent.find('input[type="checkbox"]:checked');
        var classes = '';

        $checkboxes.each(function (i, el) {
            classes += $(el).attr('data-filter-by') + ',';
        });

        filterBy = classes.substring(0, classes.length-1).trim();

        $grid.isotope();
    });

    // use value of search field to filter
    var $quicksearch = $('.quicksearch').keyup( debounce( function() {
        qsRegex = new RegExp( $quicksearch.val(), 'gi' );
        $grid.isotope();
    }, 200 ) );

    // debounce so filtering doesn't happen every millisecond
    function debounce( fn, threshold ) {
        var timeout;
        threshold = threshold || 100;
        return function debounced() {
            clearTimeout( timeout );
            var args = arguments;
            var _this = this;
            function delayed() {
                fn.apply( _this, args );
            }
            timeout = setTimeout( delayed, threshold );
        };
    }

    $( document ).ready(function() {
        //$('.partners-row .single-partner-block .logo-link').show();
    });
})(jQuery, KMDGPB.jQuery);